{#if show}
  <FieldContainer {...container}>

    <div slot="before-area">
      <slot name="before"></slot>
    </div>

    <div slot="input-area">

      {#if container.readonly}
        <Text nm pt="sm" pb="xs" width="100%">
          <pre>{value}</pre>
        </Text> 
      {/if}

      <NoteInput 
        {id} 
        {container}
        on:focus={()=>{container.focused=true;}}
        on:blur={()=>{container.focused=false;}}
        bind:value={value} />

    </div>

    <div slot="limits-area">{container.limits}</div>

    <div slot="after-area">
      <IconButton
        show={field.editor}
        on:click={(ev) => { alert("edit me !"); }}
        name="open-editor"
        {...iconButton}
      />
    </div>

  </FieldContainer>
{/if}

<script>
  import { onMount } from 'svelte'
  import { Theme } from 'svelte-stylo'
  import { Text } from 'svelte-stylo';
  import IconButton from '../../buttons/IconButton.svelte';
  import FieldContainer from '../container/FieldContainer.svelte'
  import { updateContainer } from '../container/helpers'
  import NoteInput from './_NoteInput.svelte'
  import { copyProps, TextFieldProps, FieldContainerProps } from '../properties'
  import { validateIf, exceedsMaxlength, isEmpty } from '../validators'
  import { randid } from '../helpers'

  export let
    show = true,
    value,
    container = {...FieldContainerProps},
    field = {...TextFieldProps},
    validators = [exceedsMaxlength, isEmpty];

  let
    id = null,
    layout = 'stacked',
    iconButton = Theme.variant('field-icon-button') || {};

  value = (value === null && field.initial !== null) ? field.initial : value;
  id = field.id || randid();

  $: if ($$props) {
    // copy simple props if the exist
    container = copyProps(container, $$props);
    field = copyProps(field, $$props);
  }

  $: if (field !== null && container !== null) {
    container = updateContainer(container, field, value);
  };

  $: if (value !== null) {
    container.errors = validateIf(value, field, validators)

    container.limits = field.maxlen 
      ? (value || '').length+" / "+field.maxlen
      : "";
    
    container = updateContainer(container, field, value);
  }
</script>
